module.exports = __webpack_public_path__ + "assets/3-Atlanta-Best-Tech-Sales-Opportunities.60821369.png";